export const SET_IS_AUTH_INIT = 'SET_IS_AUTH_INIT'
export const SET_IS_SIGN_IN = 'SET_IS_SIGN_IN'
export const SET_USER_PROFILE = 'SET_USER_PROFILE'
